export interface NewsItem {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  tags: string[];
  summary: string;
  date: string;
  time: string;
  author: string;
  reads: number;
  cover: string;
  content: string[];
  featured?: boolean;
}

const covers = {
  phone:
    "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20smartphone%20screen%20glowing%20with%20abstract%20social%20media%20feeds%20on%20a%20dark%20wooden%20desk%2C%20warm%20ring%20light%20glare%2C%20amber%20and%20crimson%20color%20palette%2C%20moody%20dramatic%2C%20high%20detail%20magazine%20style%2C%20soft%20shadows&width=1200&height=800&seq=art-phone&orientation=landscape",
  carpet:
    "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20empty%20press%20wall%20with%20camera%20flash%20reflections%20and%20spotlights%20at%20an%20award%20event%2C%20no%20people%2C%20warm%20gold%20and%20deep%20red%20stage%20lighting%2C%20dramatic%20glare%2C%20moody%20magazine%20style&width=1200&height=800&seq=art-carpet&orientation=landscape",
  stage:
    "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20empty%20concert%20stage%20with%20backstage%20curtains%20and%20hanging%20spotlights%2C%20warm%20amber%20and%20crimson%20haze%2C%20no%20people%2C%20moody%20atmosphere%2C%20high%20detail%20magazine%20style&width=1200&height=800&seq=art-stage&orientation=landscape",
  film:
    "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20film%20production%20equipment%20clapperboard%20camera%20and%20director%20chair%20on%20a%20soundstage%2C%20warm%20golden%20practical%20lights%2C%20no%20people%2C%20dusty%20atmosphere%2C%20moody%20magazine%20style&width=1200&height=800&seq=art-film&orientation=landscape",
  studio:
    "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20empty%20live%20broadcast%20studio%20with%20glowing%20monitors%20and%20tripod%20lights%2C%20warm%20amber%20and%20crimson%20tones%2C%20no%20people%2C%20moody%20atmosphere%2C%20high%20detail%20magazine%20style&width=1200&height=800&seq=art-studio&orientation=landscape",
  gossip:
    "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20old%20fashioned%20newspaper%20and%20magnifying%20glass%20on%20warm%20desk%20under%20a%20desk%20lamp%2C%20scattered%20headline%20clippings%2C%20amber%20and%20crimson%20lighting%2C%20no%20people%2C%20moody%20detective%20newspaper%20style&width=1200&height=800&seq=art-gossip&orientation=landscape",
  crowd:
    "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20blurred%20night%20city%20crowd%20with%20neon%20sign%20glow%20in%20warm%20crimson%20and%20gold%20tones%2C%20people%20in%20silhouette%20and%20motion%20blur%2C%20moody%20atmosphere%2C%20high%20detail%20magazine%20style&width=1200&height=800&seq=art-crowd&orientation=landscape",
  lens:
    "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20camera%20lens%20and%20clapperboard%20in%20front%20of%20bright%20bokeh%20lights%2C%20warm%20golden%20and%20crimson%20palette%2C%20no%20people%2C%20cinematic%20mood%2C%20high%20detail%20magazine%20style&width=1200&height=800&seq=art-lens&orientation=landscape",
};

export const news: NewsItem[] = [
  {
    id: "ticket-001",
    title: "起底某平台百万粉新晋网红：涨粉靠买量，人设全靠剧本演",
    category: "wanghong",
    categoryName: "新晋网红黑料",
    tags: ["买量起号", "剧本人设", "百万粉"],
    summary:
      "三个月涨到百万粉的甜妹账号，背后是精准投放加一条龙剧本，连直播PK都是提前对好的台词。镜头外的真实粉丝，可能不足三成。",
    date: "2026-09-08",
    time: "6分钟",
    author: "瓜哥",
    reads: 128430,
    cover: covers.phone,
    featured: true,
    content: [
      "一个从零起号三个月就冲到百万粉的新晋网红账号，最近被起底了。爆料显示，这条「爆红」曲线并非天赋异禀，而是一整套买量与剧本的配合结果：前期低价买量拉数据，中期靠剧情冲突留人，后期再放「素人逆袭」的故事造势。",
      "所谓的人设，同样经不起推敲。翻看早期直播切片，主播声称自己是普通上班族偶然入行，可同一位「素人」早在三年前就辗转于多个直播公会，连话术模板都几乎一致。粉丝在评论区的一句「好真实」，恰恰是剧本最想听到的评价。",
      "业内人士算了一笔账：这类账号单月投流成本通常在六位数起，而真正的自然粉丝占比往往不足三成。所谓「被看到」，只是算法在付费之后给了它更多曝光。",
      "当流量逻辑被当作人设来贩卖，翻车只是时间问题。这条爆料仍在发酵，背后究竟还有多少「偶然爆红」，恐怕只有操盘团队自己清楚。",
    ],
  },
  {
    id: "ticket-002",
    title: "选秀舞台上的「努力剧本」：练习室镜头与真实的训练时长相差多少",
    category: "lianxisheng",
    categoryName: "练习生爆料",
    tags: ["选秀剪辑", "努力人设", "训练内幕"],
    summary:
      "正片里的彻夜加练、爆哭谈心是故事线，真实的练习室则冷清得多。从镜头调度到后期剪辑，选秀「努力剧本」究竟是怎么写出来的？",
    date: "2026-09-07",
    time: "7分钟",
    author: "小报编辑部",
    reads: 96812,
    cover: covers.stage,
    featured: true,
    content: [
      "选秀节目最擅长塑造的，是「努力到感动自己」的练习生。可在镜头之外，这段故事线往往由编剧提前设计：几点加练、何时崩溃、在哪个机位哭出来最有感染力，都会提前走位。",
      "一位曾在节目组实习的工作人员透露，练习室镜头其实是分「故事拍摄」和「真实训练」两套的。故事镜头用来产素材，真实训练则通常被压缩剪辑。观众看到的那滴眼泪，可能补拍了不止一遍。",
      "这并非说练习生不努力。恰恰相反，真正决定去留的，往往是镜头外的业务能力与市场评估，剪辑能放大情绪，却很难凭空制造实力。",
      "把「努力」做成一件可以被调度的事，选秀才真正变成了一门精细的工业。而舞台下的观众，想看到的究竟是故事，还是真实的训练汗水？",
    ],
  },
  {
    id: "ticket-003",
    title: "新人演员一部戏翻车：台词全靠后期，导演被删采访回怼",
    category: "yanyuan",
    categoryName: "新人演员翻车",
    tags: ["配音争议", "导演下场", "烂演技"],
    summary:
      "一部大制作里，某新人演员被扒出全程后期配音、表情僵硬，导演一条现场采访随即被删。翻车镜头背后的剧组风波，越扒越多。",
    date: "2026-09-06",
    time: "5分钟",
    author: "阿夜",
    reads: 153220,
    cover: covers.film,
    content: [
      "热播剧集刚收官，主演之一的表演争议却盖过了作品本身。网友逐帧对比发现，该新人演员的台词几乎全部由后期配音完成，原声仅剩零星几个语气词，表情管理也被做成表情包在各平台传播。",
      "更戏剧性的是，一位自称是该剧副导演的现场片段在社交平台短暂流传，话里话外透着对拍摄进度的无奈，随后这条采访很快被撤下。剧组「天气原因重拍」的解释，与爆料时间线对不上，进一步点燃了讨论。",
      "事实上，新人压戏在剧组并不少见，真正引发反感的，是流量与实力的落差被作品原样放大。当观众为故事买单，却被主演的表演劝退，翻车的从来不只是某个镜头。",
      "业内流传一句话：观众可以用脚投票，但剧组得先学会为选角负责。这场风波能否给「带资进组」式的选角敲响警钟，还看后续。",
    ],
  },
  {
    id: "ticket-004",
    title: "素人一夜爆红的完整流水线：脚本、买赞、水军冲热搜一条龙",
    category: "suren",
    categoryName: "素人变网红黑幕",
    tags: ["流量工厂", "脚本炒作", "热搜运作"],
    summary:
      "你以为的「天降流量」，其实是一条标准化的工业流水线。从选题脚本到水军铺量，素人网红幕后有一套几乎透明的打法。",
    date: "2026-09-05",
    time: "6分钟",
    author: "吃瓜前线",
    reads: 112409,
    cover: covers.crowd,
    featured: true,
    content: [
      "每个深夜刷到的「素人一夜爆红」，背后往往不是运气，而是一条被打磨过无数遍的流水线：先由策划定一个极易传播的选题，再写好人设脚本，让素人照念照演。",
      "内容上线后，真正的重头戏才开始。运营团队会先买一批基础互动制造「即将爆火」的假象，再用账号矩阵分时段转发，最后视数据表现决定要不要追加冲热搜的预算。",
      "一位从业者坦言：素人只是镜头前的演员，真正操盘流量的是背后的策划和资金。所谓偶然，十有八九是计算好的必然。",
      "当越来越多观众识破这套玩法，「素人」这个词的分量也在悄悄改变。是继续贩卖人设，还是回归真实创作，是摆在每个想走捷径的人面前的选择题。",
    ],
  },
  {
    id: "ticket-005",
    title: "小艺人翻旧账：出道前骂战记录被扒，滤镜碎了一地",
    category: "yiren",
    categoryName: "小艺人黑历史",
    tags: ["考古", "言论翻车", "陈年旧账"],
    summary:
      "「考古」让不少小艺人栽了跟头。出道前在社交平台的尖锐言论被逐条扒出，过去随手敲下的字，成了今天反噬自己的人设黑洞。",
    date: "2026-09-04",
    time: "5分钟",
    author: "老K探班",
    reads: 87455,
    cover: covers.gossip,
    content: [
      "互联网没有记忆，但网友会替它记住。近期一位因作品小有名气的艺人，被粉丝「考古」出出道前与网友的骂战记录，言辞之激烈，与如今温润的营业人设判若两人。",
      "起初只是零散截图，随后越挖越多，连几年前匿名论坛的发言也被顺藤摸瓜对上号。面对发酵，工作室的回应含糊其辞，更让「失忆式澄清」成了新的讨论点。",
      "对许多新人来说，成名前的网络足迹是颗不定时炸弹。当时随手敲下的字，日后都会成为放大镜下的考题——不是不能犯错，而是人设一旦立得太完美，崩塌也就来得越彻底。",
      "考古本质上是观众对「真实性」的执念。与其费力删除过去，不如从一开始就诚实地面对镜头内外的自己。",
    ],
  },
  {
    id: "ticket-006",
    title: "直播PK爆粗事故：新晋主播怒怼榜一大哥后秒删，铁粉脱坑",
    category: "wanghong",
    categoryName: "新晋网红黑料",
    tags: ["直播事故", "主播脱粉", "人设崩塌"],
    summary:
      "一场直播PK中，新晋主播因连麦被压分数当众爆粗，矛头直指长期支持的榜一大哥。事后秒删记录、装无事发生，却挡不住铁粉集体脱坑。",
    date: "2026-09-03",
    time: "4分钟",
    author: "瓜哥",
    reads: 69830,
    cover: covers.studio,
    content: [
      "前一秒还在温柔喊着「家人们」，下一秒就因为PK压分当场翻脸。近日某新晋主播的直播切片在各平台疯传，一句直指榜一大哥的粗口，让直播间瞬间炸了锅。",
      "据悉，这位榜一大哥长期霸占礼物榜首位，每月真金白银不少砸。被当众数落后，大哥直接退出了粉丝群，多名老粉也跟风取关，理由出奇一致：「钱是其次，态度太伤人。」",
      "事后主播虽秒删了回放片段，并发文称「情绪上头，无心之失」，但评论区几乎一边倒。靠粉丝吃饭的生意，最忌讳的恰恰是把粉丝当工具。",
      "对靠打赏维系的新晋网红来说，情绪管理从来不是个人修养问题，而是职业素养问题。一次失控，烧掉的可能是积累数月的人气。",
    ],
  },
  {
    id: "ticket-007",
    title: "练习生选拔潜规则曝光：靠关系插队面试，素人陪跑成常态",
    category: "lianxisheng",
    categoryName: "练习生爆料",
    tags: ["选拔内幕", "关系户", "素人陪跑"],
    summary:
      "爆料显示，练习生招募的公开面试只是走过场，部分名额早在报名前就被「内定」。真正凭实力突围的素人，往往只是衬托故事的陪跑者。",
    date: "2026-09-02",
    time: "6分钟",
    author: "小报编辑部",
    reads: 78415,
    cover: covers.stage,
    content: [
      "每到招募季，练习生机构的报名通道都挤满怀揣舞台梦的年轻人。可一位曾任职于头部机构的选角助理爆料：真正决定去留的名单，早在公开面试前就已敲定大半。",
      "所谓的公开选拔，更多是给幕后运作走个流程、攒个真实素材。而关系户带来的成员，往往在业务考核中并不占优，反而挤压了素人选手的公平机会。",
      "「素人陪跑」并非个例。有被刷下的选手坦言，自己练了三年舞蹈，最终败给一个只试跳了一小段的关系户，评委的评价却高度一致地「不够突出」。",
      "舞台本该是实力的试金石，若选拔的底层逻辑变了味，寒了多少认真练习的人的心。这条爆料能否推动行业自查，仍未可知，但讨论本身，已是改变的开始。",
    ],
  },
  {
    id: "ticket-008",
    title: "新人演员接烂片养家：片酬难结、戏约靠酒局，剧组生存图鉴",
    category: "yanyuan",
    categoryName: "新人演员翻车",
    tags: ["行业生存", "片酬纠纷", "新人困境"],
    summary:
      "翻车新闻看多了，新人演员的另一面却少有人写：片酬被拖欠、试镜遥遥无期、戏约要在酒桌上谈。不是每个人都能靠关系进组。",
    date: "2026-09-01",
    time: "7分钟",
    author: "阿夜",
    reads: 65420,
    cover: covers.lens,
    content: [
      "当「新人翻车」被做成一个个猎奇标题时，更多没有名字的年轻演员，正困在行业最底层：科班出身却不被认可，跑组一年接不到一个正经角色，只能靠接一些小成本制作维持生计。",
      "可即便接了活，也不意味着收入稳定。多位受访新人反映，小剧组拖欠片酬、口头承诺随意变更是常事，讨薪往往要拉下脸面走漫长的法律程序。",
      "在非正式的聚会里，想获得一个试戏机会，有时要靠几杯酒和「有人带路」。资源高度集中的行业里，实力之外的人情牌，常常是更现实的敲门砖。",
      "新人演员的困境不是一句「不够努力」能概括的。当行业只看结果、不看过程，无数默默练习的年轻人，就成了这场名利游戏里最先被牺牲的一环。",
    ],
  },
  {
    id: "ticket-009",
    title: "素人变网红套路深：先演「全网心疼」再翻车带货，剧本全被扒",
    category: "suren",
    categoryName: "素人变网红黑幕",
    tags: ["卖惨剧本", "翻车带货", "流量变现"],
    summary:
      "从「全网心疼」到「带货翻车」，一个素人账号用了不到半年就完成了完整闭环。当苦难被写成脚本，观众的同情心就变成了待收割的流量。",
    date: "2026-08-31",
    time: "5分钟",
    author: "吃瓜前线",
    reads: 102340,
    cover: covers.phone,
    content: [
      "一个记录单亲妈妈艰辛日常的素人账号，曾让无数网友心疼落泪。可随着一场带货翻车，账号背后的操盘痕迹被逐条扒出：所谓独自带娃的坚强妈妈，其实是剧本主角。",
      "网友对比发现，账号早期的「苦难」叙事与后来剧情高度模板化，甚至多个催泪细节能在同类账号里找到一模一样的版本。从卖惨吸粉到直播带货，路径被运营得严丝合缝。",
      "这类模式并非孤例。用一个「打动人心」的人设完成涨粉，再急转进入带货收割，是不少素人孵化机构屡试不爽的套路。当真相被戳穿，掏钱的观众最先感到被背叛。",
      "同情心不该成为流量的饵料。与其让苦难变成一门生意，不如让真实的生活被真正看见——那才是内容长久不被反噬的底气。",
    ],
  },
  {
    id: "ticket-010",
    title: "小艺人机场耍大牌风波：助理被吼「不配拿我行李」视频流出",
    category: "yiren",
    categoryName: "小艺人黑历史",
    tags: ["耍大牌", "机场事件", "助理"]
    ,
    summary:
      "一段机场视频里，人气见涨的小艺人当众呵斥助理「不配碰我行李」，全程被拍下。走红后的膨胀，正成为越来越多人设崩塌的导火索。",
    date: "2026-08-30",
    time: "4分钟",
    author: "老K探班",
    reads: 58760,
    cover: covers.carpet,
    content: [
      "刚因为一部作品小有名气的小艺人，最近被一段机场视频送上了风口浪尖。画面中，他对接过行李的助理当众发火，言辞之刻薄连路人都看不下去，迅速在网上传开。",
      "事后其工作室解释为「行程疲惫的情绪失控」，并宣布涉事助理离职。可这样的公关话术，显然没说服围观群众——「疲惫不是没素质的理由」成了评论区的高赞。",
      "在粉丝经济里，越是被捧，越容易迷失分寸。一个刚冒头的艺人就开始耍大牌，观众自然会想：等真正红了，又会是怎样的做派？",
      "机场小事，照见的是人设崩塌前的裂痕。流量来得快，去得也快，能不能接住这份运气，靠的从来不是脾气，而是人品与作品的双重沉淀。",
    ],
  },
  {
    id: "ticket-011",
    title: "网红探店翻车记：摆拍「排队两小时」，隔壁空无一人的真相",
    category: "wanghong",
    categoryName: "新晋网红黑料",
    tags: ["探店作假", "摆拍", "商家联演"],
    summary:
      "「火爆到需要排队」的新晋探店视频，被眼尖网友发现店内座位全是空的——所谓的排队，不过是和商家联手上演的一出戏。",
    date: "2026-08-29",
    time: "5分钟",
    author: "瓜哥",
    reads: 83109,
    cover: covers.crowd,
    content: [
      "一条标着「排队两小时才吃到」的探店视频，最近成了打假现场。镜头里的门庭若市，与隔壁窗口拍到的店内空无一人，形成了强烈反差，网友直呼「隔着屏幕都尴尬」。",
      "复盘发现，这条视频从「排队」到「美味到流泪」的台词，都和商家提供的脚本高度吻合。所谓排队，只是商家雇人在门口凑数，配合网红完成的一次「氛围表演」。",
      "探店的本义，本该是替观众探出真实的口味与体验。当探店变成收费表演，吃亏的既是被误导去打卡的食客，也是逐渐透支信任的整个内容生态。",
      "观众不是傻子，一次穿帮就可能让账号前功尽弃。想在内容行业长久做下去，「真实」永远是最高级的流量密码。",
    ],
  },
  {
    id: "ticket-012",
    title: "练习生出道夜改名删博：旧账号里的「追星梦」还是「黑历史」？",
    category: "lianxisheng",
    categoryName: "练习生爆料",
    tags: ["考古风险", "改名删博", "出道前史"],
    summary:
      "某练习生出道当晚，社交媒体账号火速清空改名。可删得掉的旧内容，删不掉网友已经存下的截图——出道前的内容考古，正在成为行业必修课。",
    date: "2026-08-28",
    time: "4分钟",
    author: "小报编辑部",
    reads: 49988,
    cover: covers.gossip,
    content: [
      "出道即巅峰，也出道即「考古」。近日一位练习生官宣出道后，被发现连夜清空并改名了旧账号，这一「预防性操作」反而引来更多好奇，网友们纷纷翻出了早年被存下的内容。",
      "从青涩的日常分享到早年追星言论，再到可能并不成熟的观点输出，都被逐条整理成帖。工作室的解释「想给大家一个全新的我」，在评论区则被调侃为「想抹掉过去的我」。",
      "对练习生而言，过去既是成长的见证，也可能成为被断章取义的工具。与其在出道前夜手忙脚乱地删帖，不如从一开始就对公共发言多一分慎重。",
      "互联网的「删除键」并不能真正清空记忆。能够长久走下去的艺人，靠的不是完美的过去，而是敢于直面过去的坦诚。",
    ],
  },
  {
    id: "ticket-013",
    title: "新人演员台词被AI配音？剧组新技术争议，演员本人发声回应",
    category: "yanyuan",
    categoryName: "新人演员翻车",
    tags: ["AI配音", "技术争议", "演员回应"],
    summary:
      "有网友发现某新剧主演的声音疑似由AI合成，配音技术是否在替演员「作弊」引发讨论。当事人随后发文回应，一场关于表演边界的争论拉开。",
    date: "2026-08-27",
    time: "5分钟",
    author: "阿夜",
    reads: 94567,
    cover: covers.film,
    content: [
      "一部新剧热播期间，细心的网友发现主演的声音在某些情绪戏里「过于稳定」，怀疑使用了AI配音技术。话题瞬间冲上讨论榜：配音技术的进步，是解放还是取代了演员？",
      "当事人随后发文回应，承认后期在处理部分台词时借助了技术辅助，称是为「提升观感」，并坦言会反思自己对基本功的投入。这一回应，非但没平息争议，反而让「表演是否还能称之为表演」的讨论更加热闹。",
      "支持者认为，技术在为作品服务，观众看到好的结果是关键；反对者则担忧，当台词都能靠技术兜底，演员的基本功与敬业度将无从体现。",
      "技术的边界，最终要靠行业的自律来划定。对新人演员来说，与其依赖后期补救，不如把力气花在每一次开拍前的打磨上——那才是谁也替代不了的本事。",
    ],
  },
  {
    id: "ticket-014",
    title: "素人逆袭故事为何总翻车？拆解「鸡汤人设」的商业闭环",
    category: "suren",
    categoryName: "素人变网红黑幕",
    tags: ["鸡汤人设", "知识付费", "商业闭环"],
    summary:
      "从「负债逆袭」到「普通人的翻盘」，励志素人账号看似温暖，背后却常常连着卖课、带货与加盟的完整商业闭环。鸡汤喝了，钱包瘪了。",
    date: "2026-08-26",
    time: "6分钟",
    author: "吃瓜前线",
    reads: 72004,
    cover: covers.studio,
    content: [
      "「普通人的逆袭」「负债三百天还清」——这类素人励志故事，总能在深夜打动一群人。然而追根溯源，不少故事的结尾，都指向同一处：卖课、带货或是加盟引流。",
      "有用户复盘发现，自己花数千元买下的「逆袭课程」，内容大多是网上能免费搜到的公开资料拼凑，所谓「导师一对一」，也只是几个模板话术来回复用。",
      "鸡汤人设的可怕之处，在于它精准利用了对困境的焦虑。当观众把「我也想试试」的冲动，兑换成一笔笔并不理性的消费时，那些光鲜的逆袭故事，就成了最大的收割机。",
      "理性看待每一个「逆袭」：真正的改变，往往藏在一份脚踏实地的努力里，而不是别人口述的捷径之中。",
    ],
  },
  {
    id: "ticket-015",
    title: "小艺人恋情曝光后被扒「谈过好几任」，粉丝团凌晨发声明切割",
    category: "yiren",
    categoryName: "小艺人黑历史",
    tags: ["恋情曝光", "粉丝切割", "恋爱人设"],
    summary:
      "恋情一曝光，小艺人的「纯情初恋」人设就被考古打脸——过往几段感情记录被扒出。面对塌房，核心粉丝团选择在凌晨发文切割。",
    date: "2026-08-25",
    time: "4分钟",
    author: "老K探班",
    reads: 61239,
    cover: covers.carpet,
    content: [
      "一段被拍到的牵手同框，让一位小艺人的恋情冲上热搜。可真正引爆讨论的，不是恋爱本身，而是粉丝「考古」后发现：这位一直强调「母胎单身」的艺人，过往感情经历远比人设丰富。",
      "人设与现实的落差，让不少真情实感投入的粉丝大感被欺骗。事发后，该艺人的核心应援会凌晨发布长文，宣布暂停一切应援活动，被网友解读为「提前切割」。",
      "恋情本身无可厚非，问题出在把「纯情人设」当作流量卖点。当谎言被戳穿，受伤最深的往往是那些曾掏心掏肺支持的粉丝。",
      "娱乐圈从不缺人设，缺的是一份表里如一的真诚。做真实的自己，或许比苦心经营一个完美形象，更能走得长远。",
    ],
  },
];